module.exports = __webpack_public_path__ + "assets/img/recordIcon5.093310f0.png";